import React from 'react';
import PropTypes from 'prop-types';
import { get, snakeCase } from 'lodash';
import Dialog from '../../../core/layout/Dialog';
import Button from '../../../core/form/Button';
import LocaleSelect from '../../../core/form/LocaleSelect';
import Select from '../../../core/form/Select';
import { Spin } from 'antd';

const ExportCsvDialog = (props) => (
  <Dialog
    title="Export CSV"
    isOpen={props.isOpen}
    onCancel={props.onClose}
    width={700}
    actions={[
      <Button key="discardButton" type="default" label="Cancel" onClick={props.onClose} disabled={props.submitting} />,
      <Button
        key="confirmButton"
        type="primary"
        label="Export"
        onClick={props.onDownload}
        disabled={props.submitting || props.downloadError}
      />,
    ]}
  >
    {props.downloadError ? (
      <div
        style={{
          flex: 1,
          display: 'flex',
          height: '300px',
          width: '100%',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
        }}
      >
        <span>The file could not be generated.</span>
      </div>
    ) : props.submitting ? (
      <div
        style={{
          flex: 1,
          display: 'flex',
          height: '300px',
          width: '100%',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
        }}
      >
        <Spin size="large" />
        <span style={{ marginTop: '30px' }}>Exporting file...</span>
      </div>
    ) : (
      <React.Fragment>
        <Select
          required
          disabled={props.submitting}
          label="Type"
          placeholder="Select type..."
          value={get(props.values, 'type', '')}
          onChange={(value) => props.onChange('type', value)}
          errorText={get(props.errors, 'type', '')}
          options={['All', 'Student', 'Kids', 'Parents', 'Push Notifications'].map((option) => ({
            value: snakeCase(option).toUpperCase(),
            label: option,
          }))}
        />
        <LocaleSelect
          disabled={props.submitting}
          value={get(props.values, 'locale', '')}
          onChange={(value) => props.onChange('locale', value)}
          errorText={get(props.errors, 'locale', null)}
        />
        <span style={{ marginTop: '25px', marginBottom: '6px', display: 'block' }}>Header example:</span>
        <div
          style={{
            display: 'flex',
            height: '30px',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'row',
          }}
        >
          {['Type', 'Key', 'English', get(props.values, 'locale', '')].map((type) => (
            <span
              style={{
                border: '1px solid #d7d7d7',
                height: '100%',
                flex: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 'bold',
              }}
            >
              {type}
            </span>
          ))}
        </div>
      </React.Fragment>
    )}
  </Dialog>
);

ExportCsvDialog.propTypes = {
  values: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onDownload: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  submitting: PropTypes.bool,
  errors: PropTypes.object,
  downloadError: PropTypes.bool,
};

ExportCsvDialog.defaultProps = {
  values: {},
  isOpen: false,
  submitting: false,
  errors: null,
  downloadError: false,
};

export default ExportCsvDialog;
